import { useGetIdentity, useGetOne } from "ra-core";

import type { Sale } from "../types";

/** the current user's extension (sales.phone_ext), null when none is set */
export const useMyPhoneExt = () => {
  const { identity } = useGetIdentity();
  const { data, isPending } = useGetOne<Sale>(
    "sales",
    { id: identity?.id as Sale["id"] },
    { enabled: identity?.id != null },
  );
  const ext = data?.phone_ext?.trim() || null;
  return { ext, isPending: identity?.id == null || isPending };
};
